import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingCount: 0,
  progress: 10,
  activeRequests: [],
  apisCompleted: false,
  progressReachedTarget: false,
  isCompleting: false,
  loadingCategories: {
    critical: 0,
    silent: 0,
  },
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    startLoading: (state, action) => {
      const { requestId = "default", category = "critical" } =
        action.payload || {};

      if (!state.activeRequests.includes(requestId)) {
        state.activeRequests.push(requestId);
        state.loadingCategories[category] += 1;

        if (category === "critical") {
          state.loadingCount += 1;
        }
      }

      if (state.loadingCount === 1) {
        state.apisCompleted = false;
        state.progressReachedTarget = false;
        state.isCompleting = false;
      }
    },

    endLoading: (state, action) => {
      const { requestId = "default", category = "critical" } =
        action.payload || {};

      const index = state.activeRequests.indexOf(requestId);
      if (index !== -1) {
        state.activeRequests.splice(index, 1);
        state.loadingCategories[category] = Math.max(
          0,
          state.loadingCategories[category] - 1
        );

        if (category === "critical") {
          state.loadingCount = Math.max(0, state.loadingCount - 1);
        }
      }

      if (state.loadingCount === 0) {
        state.apisCompleted = true;
      }
    },

    setProgress: (state, action) => {
      state.progress = action.payload;
      if (action.payload >= 94) {
        state.progressReachedTarget = true;
      }
    },

    setCompleting: (state, action) => {
      state.isCompleting = action.payload;
    },

    resetLoading: (state) => {
      state.loadingCount = 0;
      state.progress = 10;
      state.activeRequests = [];
      state.apisCompleted = false;
      state.progressReachedTarget = false;
      state.isCompleting = false;
      state.loadingCategories = {
        critical: 0,
        silent: 0,
      };
    },
  },
});

export const {
  startLoading,
  endLoading,
  setProgress,
  setCompleting,
  resetLoading,
} = loadingSlice.actions;

export default loadingSlice.reducer;
